<ion-header>
  <ion-toolbar>
    <ion-title>{{ title }}</ion-title>
    <ion-buttons slot="end">
      <ion-button *ngIf="showInstallButton" (click)="installPWA()" title="Install App">
        <ion-icon name="download-outline" color="primary" style="font-size: 1.5em;"></ion-icon>
      </ion-button>
      <ion-button (click)="onHelp()" title="Help">
        <ion-icon name="information-circle" color="primary" style="font-size: 1.5em;"></ion-icon>
      </ion-button>
      <ion-button (click)="onSignOut()" title="Sign out">
        <ion-icon name="log-out-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
